import { SESSION_STORAGE_WHITELABEL_TOKEN } from '../constants';
import { sessionStorage } from './storage';

/**
 * Хранилище whitelabel токена.
 *
 * sessionStorage из './storage' сам защищает от блокировки доступа к
 * window.sessionStorage внутри iframe: если хранилище недоступно, используется
 * in-memory фоллбэк (OwnStorage).
 */
export const getWhitelabelToken = () => sessionStorage.getItem(SESSION_STORAGE_WHITELABEL_TOKEN);

export const setWhitelabelToken = (value: string) => {
    sessionStorage.setItem(SESSION_STORAGE_WHITELABEL_TOKEN, value);
};

export const removeWhitelabelToken = () => {
    sessionStorage.removeItem(SESSION_STORAGE_WHITELABEL_TOKEN);
};
